import { getCartCacheStorage } from '@jsmdg/browser-storage';
import { type CartPreview } from '../../shared/types';

class CartCache {
    private storage = getCartCacheStorage<CartPreview>();

    public get(): CartPreview | null {
        return this.storage.get();
    }

    public set(cart: CartPreview, ttl?: number): void {
        this.storage.set(cart, ttl);
    }

    public clear(): void {
        this.storage.remove();
    }

    public getStale(): CartPreview | null {
        return this.storage.getStale();
    }

    public invalidateOnMutation(): void {
        this.clear();
    }
}

const cartCache = new CartCache();

export { cartCache };
